// Companion/blocks/DocumentExcerptBlock.tsx
import type { ChatDocumentExcerptBlockPayload } from '@/types/chatBlocks';
import McGrawHillQuoteCard from '../../../../../mcgrawHill/McGrawHillQuoteCard'; // mcgraw-hill

const Excerpt = ({ text }: { text: string }) => (
  <blockquote className="m-0 whitespace-pre-wrap border-l-2 border-border-subtle pl-3 text-sm text-fg-primary">
    {text}
  </blockquote>
);

/**
 * A page of a lecture document, added from a source pill (ORA-514). The body
 * is the cited excerpt — the same bounded text the citation carried — so the
 * student can read what the answer leaned on without leaving the thread.
 */
const DocumentExcerptBlock = ({
  payload,
}: {
  payload: ChatDocumentExcerptBlockPayload;
}) => {
  if (payload.source === 'chat_document') {
    // mcgraw-hill: only McGraw Hill answers quote chat documents.
    return <McGrawHillQuoteCard payload={payload} />;
  }

  return payload.excerpt ? (
    <Excerpt text={payload.excerpt} />
  ) : (
    <p className="m-0 text-xs text-fg-secondary">
      No excerpt is available for this page.
    </p>
  );
};

export default DocumentExcerptBlock;
